var React = require('react');

function Learn (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"2.5","y1":"2.5","x2":"2.5","y2":"13.5","stroke":"currentColor","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"5","y1":"2.5","x2":"5","y2":"13.5","stroke":"currentColor","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M7.5 12.5V3.60772C7.5 2.86684 8.27753 2.38321 8.94208 2.71074L12.9421 4.68217C13.2837 4.85053 13.5 5.19831 13.5 5.57914V12.5C13.5 13.0523 13.0523 13.5 12.5 13.5H8.5C7.94772 13.5 7.5 13.0523 7.5 12.5Z","stroke":"currentColor","strokeLinecap":"round","key":2})]);
}

Learn.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Learn;

Learn.default = Learn;
